import React, { useState, useEffect } from 'react';
import { Button, Input, Tag, Space } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { styled } from '@superset-ui/core';

const ColorMapWrapper = styled.div`
  padding: 8px;
`;

const ColorItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
`;

interface ColorMap {
  category: string;
  color: string;
}

// Nilai default untuk color mapping
const defaultColorMaps: ColorMap[] = [
  { category: 'Stop', color: '#FF0000' },
  { category: 'Idle', color: '#FFFF00' },
  { category: 'Rest', color: '#0000FF' },
  { category: 'Running', color: '#008000' },
  { category: 'Status_On', color: '#008000' },
  { category: 'Status_Off', color: '#FF0000' },
];

interface ColorMapControlProps {
  value: Array<{ category: string; color: string }>;
  onChange: (value: Array<{ category: string; color: string }>) => void;
}

export default function ColorMapControl({
  value,
  onChange,
}: ColorMapControlProps) {
  const [colorMaps, setColorMaps] = useState(value || defaultColorMaps);

  // Update formData ketika colorMaps berubah
  useEffect(() => {
    onChange!(colorMaps);
  }, [colorMaps]);

  const handleAddColor = () => {
    setColorMaps([...colorMaps, { category: '', color: '#000000' }]);
  };

  const handleRemoveColor = (index: number) => {
    const newColorMaps = colorMaps.filter((_, i) => i !== index);
    setColorMaps(newColorMaps);
  };

  const handleColorChange = (
    index: number,
    field: keyof ColorMap,
    value: string,
  ) => {
    const newColorMaps = [...colorMaps];
    newColorMaps[index][field] = value;
    setColorMaps(newColorMaps);
    onChange?.(newColorMaps);
  };

  return (
    <ColorMapWrapper>
      {colorMaps.map((item, index) => (
        <ColorItem key={index}>
          <Input
            placeholder="Category"
            value={item.category}
            onChange={e => handleColorChange(index, 'category', e.target.value)}
            style={{ width: 120 }}
          />
          <Input
            type="color"
            value={item.color}
            onChange={e => handleColorChange(index, 'color', e.target.value)}
            style={{ width: 60 }}
          />
          <Tag color={item.color}>{item.category || 'New Category'}</Tag>
          <Button
            icon={<DeleteOutlined />}
            onClick={() => handleRemoveColor(index)}
            type="text"
            danger
          />
        </ColorItem>
      ))}
      <Button
        type="dashed"
        onClick={handleAddColor}
        icon={<PlusOutlined />}
        style={{ width: '100%' }}
      >
        Add Color Mapping
      </Button>
    </ColorMapWrapper>
  );
}
